const maximumDaysOfZeroBalances = 3;
/**
 * Removes the ending zero balances in an array of data.
 *
 * ex: [100, 0, 0] -> [100, 100, 100] // replaces trailing zeros with the last good data
 * ex: [1, 2, 3] -> [1, 2, 3] // if there are no zeros do nothing
 *
 * @template T - The type of the data elements.
 * @param {T[]} originalData - The original array of data.
 * @returns {T[]} - The array of data with zero balances removed from the end of the array.
 */
export const smoothEndingZeroBalances = (originalData) => {
    if (originalData.length === 0) {
        return originalData;
    }
    const endingZeroBalances = originalData.reduceRight(([doneCounting, count], current) => {
        // We are done counting zeros
        if (doneCounting) {
            return [doneCounting, count];
        }
        if (current.balanceOnEndDay === 0) {
            return [false, count + 1];
        }
        return [true, count];
    }, 
    // [0]: Have we stopped counting zeros?
    // [1]: Number of zeros we have counted
    [false, 0]);
    const numberOfEndingZeroBalances = endingZeroBalances[1];
    if (numberOfEndingZeroBalances <= maximumDaysOfZeroBalances) {
        const dataToKeep = originalData.slice(0, originalData.length - numberOfEndingZeroBalances);
        const lastGoodData = dataToKeep.slice(-1)[0];
        // If we do not have a last data point return original
        if (lastGoodData === undefined) {
            return originalData;
        }
        return originalData.map((d, idx) => idx < originalData.length - numberOfEndingZeroBalances
            ? d
            : {
                ...d,
                balanceOnEndDay: lastGoodData.balanceOnEndDay,
                returnsSinceStartDay: lastGoodData.returnsSinceStartDay,
            });
    }
    // return original
    return originalData;
};
//# sourceMappingURL=smoothEndingZeroBalances.js.map